export function log(...data: any[]) {
  if (window.midastrackr.debug) {
    console.log("[MidasTrackr] " + new Date().toISOString() + " -", ...data);
  }
}

export async function delayAsync(timeout = 500) {
  return new Promise(res => setTimeout(res, timeout));
}
